import React from 'react';
import { useTranslation } from 'react-i18next';
import GameSlide from '../components/GameSlide/GameSlide';
import { GamesPageContainer } from './Pages.styles';
import { SEO } from '../components/SEO/SEO';
import { StructuredData } from '../components/StructuredData/StructuredData';
import { STRUCTURED_DATA } from '../constants/seo.constants';

const GamesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GamesPageContainer id="games">
      <SEO
        title={t('seo.games.title')}
        description={t('seo.games.description')}
        keywords={t('seo.games.keywords')}
        canonicalUrl="/games"
        type="website"
      />
      <StructuredData data={STRUCTURED_DATA.VIDEO_GAMES.CATERVA} />
      <StructuredData data={STRUCTURED_DATA.VIDEO_GAMES.SAN_MARTIN} />
      <GameSlide />
    </GamesPageContainer>
  );
};

export default GamesPage;
